import _ from 'lodash';
import {Tab} from '../../../../ui-toolkit';
import React from 'react';
import {usePreferences} from '../../../../ducks/PreferencesContext';

export function EntityTableTabs({formatter}) {
    const {preferences, setPreference} = usePreferences();
    const tabs = _.get(formatter, 'settings.tabs', []);
    if (!tabs || !_.some(tabs, (tab) => tab.displayName)) return null;

    const nonEmptyTabs = _.filter(tabs, (t) => t.displayName);
    const currentTabIx = _.get(preferences, 'tabIx', 0);

    function applyTab(tabIx) {
        setPreference('tabIx', tabIx);
    }

    return (
        <Tab>
            {_.map(nonEmptyTabs, (tab, ix) => (
                <Tab.Option key={ix} onClick={() => applyTab(ix)} active={currentTabIx === ix}>
                    {tab.displayName}
                </Tab.Option>
            ))}
        </Tab>
    );
}
